import {Orders} from "../models/Orders";
import {Box} from "../models/Box";

export const buildBoxes = (inputs: Array<Record<string, number>>) =>
    inputs.map(i => new Box(i.length, i.width, i.height, i.amount));

export const normalizePhone = (masked: string) =>
    "8" + masked.replaceAll("(", "").replaceAll(") ", "").replaceAll("-", "");

export const shiftDateToMidnightPlus1 = (d: Date) =>
    new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1);

export const createOrder = (params: {
    entity: string;
    departureDate: Date;
    acceptanceDate: Date;
    phone: string;
    sendCity: string;
    store: string;
    supplyType: string;
    volume: number;
    price: number;
    willTaken: boolean;
    payment: boolean;
    comment: string;
    ozonNumber: string;
    supplyId: number;
    paymentStatus?: boolean;
    changeable?: boolean;
    status?: string;
    base?: Partial<Orders>;
}) => {
    const order: Orders = {
        entity: params.entity,
        departureDate: shiftDateToMidnightPlus1(new Date(params.departureDate)),
        acceptanceDate: shiftDateToMidnightPlus1(new Date(params.acceptanceDate)),
        phoneNumber: params.phone,
        sendCity: params.sendCity,
        store: params.store,
        supplyType: params.supplyType,
        volume: params.volume,
        price: params.price,
        willTaken: params.willTaken,
        paymentSite: params.payment,
        comment: params.comment,
        numberOzon: params.ozonNumber,
        supplyId: params.supplyId,
        paymentStatus: params.paymentStatus,
        changeable: params.changeable,
        status: params.status,
        id: params.base?.id,
    };

    return order;
};
